<template lang="pug">
div(class="xl12 l12 m12 s12 insety-16 border-bottom")
    label(class="bold bond-title fg70") {{ $t('maturity_date') }}
    div(class="xl12 l12 m12 s12 flex-flex after-16")
        div(class="matdate")
            label(class="fg50 fs7 insety-8") {{ $t('from') }}
            ib-field-date(class="inset-8 outset-0",
                width="100%", type="text",
                @input="enableEndDate",
                @change="checkDates"
                v-model="maturityDates[0]",
                uppercase=true name="startDate")
        div(class="outsetx-16 matdate")
            label(class="fg50 fs7 insety-8") {{ $t('to') }}
            ib-field-date(class="inset-8 outset-0",
                width="100%", type="text",
                @change="checkDates"
                :disabled="hide"
                v-model="maturityDates[1]"
                uppercase=true name="endDate")
</template>

<script>
    import mxGb from '../mixin/mixin-global'
    export default {
        name: 'MaturityDate',

        mixins: [ mxGb ],

        props: ['disabled'],

        data() {
            return {
                maturityDates: [],
                hide: true,
           }
        },

        mounted() {
            this.$nextTick(() => {
                if (this.subFilters) {
                    const minDate = this.getFilterValue('maturityDateAbove');
                    const maxDate = this.getFilterValue('maturityDateBelow');
                    this.maturityDates = [ minDate, maxDate ];
                    if (maxDate) { this.enableEndDate(); }
                    this.checkDates();
                }
            });
        },

        methods: {
            enableEndDate() {
                this.hide = false;
            },
            checkDates() {
                if(!this.maturityDates[0] && !this.maturityDates[1]) {
                    this.reset();
                }
                this.$emit('showResults', this.maturityDates);
            },
            reset() {
                this.maturityDates = [];
            }
        },
    }
</script>

<style lang="less" scoped>

</style>